import {USER_THEME_KEY} from "../constants";
import {themes} from "../contexts/ThemeContext";

export const getStoredUserTheme = (): string => {
  const theme: string | null = window.localStorage.getItem(USER_THEME_KEY);
  if (theme) {
    return theme;
  }
  return themes.dark;
};
